import type { ShapeKind } from "@/types";
import { SHAPE_KINDS, shapeDefaultSize } from "@/constants";
import { ShapeGlyph } from "./ShapeCard";

const LABELS: Record<ShapeKind, string> = {
  rectangle: "Rectangle",
  square: "Square",
  circle: "Circle",
  triangle: "Triangle",
};

export function ShapePanel({
  activeKind,
  onSelect,
}: {
  activeKind: ShapeKind | null;
  onSelect: (kind: ShapeKind) => void;
}) {
  return (
    <div
      style={{
        position: "absolute",
        bottom: "calc(100% + 8px)",
        left: "50%",
        transform: "translateX(-50%)",
        background: "var(--card)",
        border: "1px solid var(--border)",
        borderRadius: 12,
        boxShadow: "0 4px 20px rgba(0,0,0,0.12), 0 1px 4px rgba(0,0,0,0.08)",
        padding: 12,
        width: 256,
        pointerEvents: "auto",
      }}
    >
      <div style={{
        fontSize: 10,
        fontWeight: 600,
        color: "var(--muted-foreground)",
        marginBottom: 8,
        textTransform: "uppercase",
        letterSpacing: "0.06em",
      }}>
        Shapes
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 6 }}>
        {SHAPE_KINDS.map((kind) => {
          // Render each glyph at its true aspect ratio so a rectangle reads as a
          // rectangle (not a square) inside the square button.
          const { w, h } = shapeDefaultSize(kind);
          const aspect = w / h;
          const gw = aspect >= 1 ? "100%" : `${aspect * 100}%`;
          const gh = aspect >= 1 ? `${(1 / aspect) * 100}%` : "100%";
          return (
            <button
              key={kind}
              onClick={() => onSelect(kind)}
              title={LABELS[kind]}
              style={{
                aspectRatio: "1",
                borderRadius: 8,
                cursor: "pointer",
                border: activeKind === kind ? "1.5px solid #0091ff" : "1px solid var(--border)",
                background: "var(--muted)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 12,
              }}
            >
              <ShapeGlyph kind={kind} color="var(--muted-foreground)" width={gw} height={gh} />
            </button>
          );
        })}
      </div>
    </div>
  );
}
